// 1.

// import { useEffect, useState, useContext } from "react";
// import { Modal, Button, Form, Row, Col } from "react-bootstrap";
// import { AppThemeContext } from "../../../../context/AppThemeContext";
// import { BaseUrl } from "../../../../api/AxiosApi";

// const UserDetailUpdate = ({ show, handleClose, userData, onUpdate }) => {

//     const { PrimaryColor } = useContext(AppThemeContext);

//     const [formData, setFormData] = useState({
//         userId: "",
//         username: "",
//         plant_capacity: "",
//         dc_capacity: "",
//         address: "",
//         city: "",
//         currency: "",
//         lat: "",
//         long: "",
//         rate: "",
//         co2_rate: "",
//         total_modules: "",
//         module_capacity: "",
//         password: "",
//         module_make: "",
//     });

//     const LOGIN_ID = sessionStorage.getItem("LoginID");

//     useEffect(() => {
//         if (userData) {
//             setFormData({
//                 userId: userData.user_id || "",
//                 username: userData.username || "",
//                 plant_capacity: userData.plant_capacity || "",
//                 dc_capacity: userData.dc_capacity || "",
//                 address: userData.address || "",
//                 city: userData.city || "",
//                 currency: userData.currency || "",
//                 lat: userData.lat || "",
//                 long: userData.long || "",
//                 rate: userData.rate || "",
//                 co2_rate: userData.co2_rate || "",
//                 total_modules: userData.total_modules || "",
//                 module_capacity: userData.module_capacity || "",
//                 password: userData.password || "",
//                 module_make: userData.moudle_make || "",
//             });
//         }
//     }, [userData]);

//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         setFormData((prev) => ({
//             ...prev,
//             [name]: value
//         }));
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         try {
//             const queryParams = new URLSearchParams({
//                 USER_NAME: formData.username,
//                 PLANT_CAPACITY: formData.plant_capacity,
//                 DC_CAPACITY: formData.dc_capacity,
//                 ADDRESS: formData.address,
//                 CITY: formData.city,
//                 CURRENCY: formData.currency,
//                 LATITUDE: formData.lat,
//                 LONGITUDE: formData.long,
//                 RATE: formData.rate,
//                 CO2: formData.co2_rate,
//                 TOTAL_MODULES: formData.total_modules,
//                 MODULE_CAPACITY: formData.module_capacity,
//                 MODULE_MAKE: formData.module_make,
//                 PASSWORD: formData.password,
//                 SKey: "XYZ"
//             }).toString();

//             const body = new URLSearchParams({
//                 USER_ID: LOGIN_ID,
//                 UPDATE_ID: formData.userId,
//                 TYPE_ID: "U"
//             }).toString();

//             const url = `${BaseUrl}UPDATE_USERrrrrrrrrrrrrrrrrrrrrrrrrrr?${queryParams}`;

//             const res = await fetch(url, {
//                 method: "POST",
//                 headers: {
//                     "Content-Type": "application/x-www-form-urlencoded"
//                 },
//                 body: body
//             });

//             const data = await res.json();

//             if (data.success) {
//                 onUpdate(data);
//                 handleClose();
//             }

//         } catch (err) {
//             console.error(err);
//         }
//     };

//     return (
//         <Modal show={show} onHide={handleClose} centered size="lg">

//             {/* <Modal.Header closeButton style={{ background: PrimaryColor }}>
//         <Modal.Title>Update User Details</Modal.Title>
//       </Modal.Header> */}

//             <Modal.Header
//                 closeButton
//                 style={{ background: PrimaryColor, color: "#fff" }}
//             >
//                 <Modal.Title style={{ color: "#fff" }}>
//                     Update User Details
//                 </Modal.Title>
//             </Modal.Header>

//             <Modal.Body>
//                 <Form onSubmit={handleSubmit}>

//                     <Row>

//                         <Col md={6}>
//                             <Form.Group className="mb-2">
//                                 <Form.Label>User ID</Form.Label>
//                                 <Form.Control type="text" value={formData.userId} readOnly />
//                             </Form.Group>
//                         </Col>

//                         <Col md={6}>
//                             <Form.Group className="mb-2">
//                                 <Form.Label>Password</Form.Label>
//                                 <Form.Control name="password" value={formData.password} onChange={handleChange} />
//                             </Form.Group>
//                         </Col>


//                         <Col md={6}>
//                             <Form.Group className="mb-2">
//                                 <Form.Label>User Name</Form.Label>
//                                 <Form.Control name="username" value={formData.username} onChange={handleChange} />
//                             </Form.Group>
//                         </Col>

//                         <Col md={6}>
//                             <Form.Group className="mb-2">
//                                 <Form.Label>City</Form.Label>
//                                 <Form.Control name="city" value={formData.city} onChange={handleChange} />
//                             </Form.Group>
//                         </Col>

//                         <Col md={6}>
//                             <Form.Group className="mb-2">
//                                 <Form.Label>Plant Capacity</Form.Label>
//                                 <Form.Control name="plant_capacity" value={formData.plant_capacity} onChange={handleChange} />
//                             </Form.Group>
//                         </Col>

//                         <Col md={6}>
//                             <Form.Group className="mb-2">
//                                 <Form.Label>DC Capacity</Form.Label>
//                                 <Form.Control name="dc_capacity" value={formData.dc_capacity} onChange={handleChange} />
//                             </Form.Group>
//                         </Col>

//                         <Col md={6}>
//                             <Form.Group className="mb-2">
//                                 <Form.Label>Currency</Form.Label>
//                                 <Form.Control name="currency" value={formData.currency} onChange={handleChange} />
//                             </Form.Group>
//                         </Col>

//                         <Col md={6}>
//                             <Form.Group className="mb-2">
//                                 <Form.Label>Rate</Form.Label>
//                                 <Form.Control name="rate" value={formData.rate} onChange={handleChange} />
//                             </Form.Group>
//                         </Col>

//                         <Col md={6}>
//                             <Form.Group className="mb-2">
//                                 <Form.Label>Latitude</Form.Label>
//                                 <Form.Control name="lat" value={formData.lat} onChange={handleChange} />
//                             </Form.Group>
//                         </Col>

//                         <Col md={6}>
//                             <Form.Group className="mb-2">
//                                 <Form.Label>Longitude</Form.Label>
//                                 <Form.Control name="long" value={formData.long} onChange={handleChange} />
//                             </Form.Group>
//                         </Col>

//                         <Col md={6}>
//                             <Form.Group className="mb-2">
//                                 <Form.Label>CO2</Form.Label>
//                                 <Form.Control name="co2_rate" value={formData.co2_rate} onChange={handleChange} />
//                             </Form.Group>
//                         </Col>

//                         <Col md={6}>
//                             <Form.Group className="mb-2">
//                                 <Form.Label>Total Modules</Form.Label>
//                                 <Form.Control name="total_modules" value={formData.total_modules} onChange={handleChange} />
//                             </Form.Group>
//                         </Col>

//                         <Col md={6}>
//                             <Form.Group className="mb-2">
//                                 <Form.Label>Module Capacity</Form.Label>
//                                 <Form.Control name="module_capacity" value={formData.module_capacity} onChange={handleChange} />
//                             </Form.Group>
//                         </Col>

//                         <Col md={6}>
//                             <Form.Group className="mb-2">
//                                 <Form.Label>Module Make</Form.Label>
//                                 <Form.Control name="module_make" value={formData.module_make} onChange={handleChange} />
//                             </Form.Group>
//                         </Col>


//                     </Row>

//                     {/* ADDRESS FULL WIDTH */}
//                     <Form.Group className="mb-2">
//                         <Form.Label>Address</Form.Label>
//                         <Form.Control
//                             as="textarea"
//                             rows={2}
//                             name="address"
//                             value={formData.address}
//                             onChange={handleChange}
//                         />
//                     </Form.Group>

//                     <div className="text-end mt-3">
//                         <Button onClick={handleClose} style={{ marginRight: "10px" }}>
//                             Cancel
//                         </Button>

//                         <Button type="submit" style={{ background: PrimaryColor }}>
//                             Update
//                         </Button>
//                     </div>

//                 </Form>
//             </Modal.Body>
//         </Modal>
//     );
// };

// export default UserDetailUpdate;

// 2.


// import { useEffect, useState, useContext } from "react";
// import { Modal, Button, Form, Row, Col } from "react-bootstrap";

// import { AppThemeContext } from "../../../../context/AppThemeContext";
// import { BaseUrl } from "../../../../api/AxiosApi";

// const UserDetailUpdate = ({
//   show,
//   handleClose,
//   userData,
//   onUpdate,
// }) => {
//   const { PrimaryColor } = useContext(AppThemeContext);

//   const [formData, setFormData] = useState({
//     userId: "",
//     username: "",
//     plant_capacity: "",
//     dc_capacity: "",
//     address: "",
//     city: "",
//     currency: "",
//     lat: "",
//     long: "",
//     rate: "",
//     co2_rate: "",
//     total_modules: "",
//     module_capacity: "",
//     module_make: "",
//   });

//   const LOGIN_ID = sessionStorage.getItem("LoginID");

//   useEffect(() => {
//     if (userData) {
//       setFormData({
//         userId: userData.user_id || "",
//         username: userData.username || "",
//         plant_capacity: userData.plant_capacity || "",
//         dc_capacity: userData.dc_capacity || "",
//         address: userData.address || "",
//         city: userData.city || "",
//         currency: userData.currency || "",
//         lat: userData.lat || "",
//         long: userData.long || "",
//         rate: userData.rate || "",
//         co2_rate: userData.co2_rate || "",
//         total_modules: userData.total_modules || "",
//         module_capacity: userData.module_capacity || "",
//         module_make: userData.module_make || "",
//       });
//     }
//   }, [userData]);

//   // HANDLE CHANGE
//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     setFormData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   // SUBMIT UPDATE
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     try {
//       const queryParams = new URLSearchParams({
//         USER_NAME: formData.username,
//         PLANT_CAPACITY: formData.plant_capacity,
//         DC_CAPACITY: formData.dc_capacity,
//         ADDRESS: formData.address,
//         CITY: formData.city,
//         CURRENCY: formData.currency,
//         LATITUDE: formData.lat,
//         LONGITUDE: formData.long,
//         RATE: formData.rate,
//         CO2: formData.co2_rate,
//         TOTAL_MODULES: formData.total_modules,
//         MODULE_CAPACITY: formData.module_capacity,
//         MODULE_MAKE: formData.module_make,
//         SKey: "XYZ",
//       }).toString();

//       const body = new URLSearchParams({
//         USER_ID: LOGIN_ID,
//         UPDATE_ID: formData.userId,
//         TYPE_ID: "U",
//       }).toString();

//       const url = `${BaseUrl}UPDATE_USER?${queryParams}`;

//       const res = await fetch(url, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/x-www-form-urlencoded",
//         },
//         body: body,
//       });

//       const data = await res.json();

//       console.log("UPDATE RESPONSE:", data);

//       if (data.success || data.STATUS === "SUCCESS") {
//         onUpdate(data);
//         handleClose();
//       } else {
//         alert("Update failed");
//       }
//     } catch (err) {
//       console.error(err);
//       alert("Something went wrong");
//     }
//   };

//   return (
//     <Modal show={show} onHide={handleClose} centered size="lg">
//       {/* HEADER */}
//       <Modal.Header
//         closeButton
//         style={{
//           background: PrimaryColor,
//           color: "#fff",
//         }}
//       >
//         <Modal.Title style={{ color: "#fff" }}>
//           Update User Details
//         </Modal.Title>
//       </Modal.Header>

//       <Modal.Body>
//         <Form onSubmit={handleSubmit}>
//           <Row>
//             {/* USER ID */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>User ID</Form.Label>

//                 <Form.Control
//                   type="text"
//                   value={formData.userId}
//                   readOnly
//                 />
//               </Form.Group>
//             </Col>

//             {/* USER NAME */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>User Name</Form.Label>

//                 <Form.Control
//                   name="username"
//                   value={formData.username}
//                   onChange={handleChange}
//                 />
//               </Form.Group>
//             </Col>

//             {/* CITY */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>City</Form.Label>

//                 <Form.Control
//                   name="city"
//                   value={formData.city}
//                   onChange={handleChange}
//                 />
//               </Form.Group>
//             </Col>

//             {/* PLANT CAPACITY */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>Plant Capacity</Form.Label>

//                 <Form.Control
//                   name="plant_capacity"
//                   value={formData.plant_capacity}
//                   onChange={handleChange}
//                 />
//               </Form.Group>
//             </Col>

//             {/* DC CAPACITY */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>DC Capacity</Form.Label>

//                 <Form.Control
//                   name="dc_capacity"
//                   value={formData.dc_capacity}
//                   onChange={handleChange}
//                 />
//               </Form.Group>
//             </Col>

//             {/* CURRENCY */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>Currency</Form.Label>

//                 <Form.Control
//                   name="currency"
//                   value={formData.currency}
//                   onChange={handleChange}
//                 />
//               </Form.Group>
//             </Col>

//             {/* RATE */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>Rate</Form.Label>

//                 <Form.Control
//                   name="rate"
//                   value={formData.rate}
//                   onChange={handleChange}
//                 />
//               </Form.Group>
//             </Col>

//             {/* LATITUDE */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>Latitude</Form.Label>

//                 <Form.Control
//                   name="lat"
//                   value={formData.lat}
//                   onChange={handleChange}
//                 />
//               </Form.Group>
//             </Col>

//             {/* LONGITUDE */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>Longitude</Form.Label>

//                 <Form.Control
//                   name="long"
//                   value={formData.long}
//                   onChange={handleChange}
//                 />
//               </Form.Group>
//             </Col>

//             {/* CO2 */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>CO2 Reduction</Form.Label>

//                 <Form.Control
//                   name="co2_rate"
//                   value={formData.co2_rate}
//                   onChange={handleChange}
//                 />
//               </Form.Group>
//             </Col>

//             {/* TOTAL MODULES */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>Total Modules</Form.Label>

//                 <Form.Control
//                   name="total_modules"
//                   value={formData.total_modules}
//                   onChange={handleChange}
//                 />
//               </Form.Group>
//             </Col>

//             {/* MODULE CAPACITY */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>Module Capacity</Form.Label>

//                 <Form.Control
//                   name="module_capacity"
//                   value={formData.module_capacity}
//                   onChange={handleChange}
//                 />
//               </Form.Group>
//             </Col>

//             {/* MODULE MAKE */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>Module Make</Form.Label>

//                 <Form.Control
//                   name="module_make"
//                   value={formData.module_make}
//                   onChange={handleChange}
//                 />
//               </Form.Group>
//             </Col>
//           </Row>

//           {/* ADDRESS */}
//           <Form.Group className="mb-2">
//             <Form.Label>Address</Form.Label>

//             <Form.Control
//               as="textarea"
//               rows={2}
//               name="address"
//               value={formData.address}
//               onChange={handleChange}
//             />
//           </Form.Group>

//           {/* BUTTONS */}
//           <div className="text-end mt-2">
//             <Button
//               variant="secondary"
//               onClick={handleClose}
//               style={{ marginRight: "10px" }}
//             >
//               Cancel
//             </Button>

//             <Button
//               type="submit"
//               style={{
//                 background: PrimaryColor,
//                 border: "none",
//               }}
//             >
//               Update
//             </Button>
//           </div>
//         </Form>
//       </Modal.Body>
//     </Modal>
//   );
// };

// export default UserDetailUpdate;

// 3. ISME UNIT LGAYA HAI 

// import { useEffect, useState, useContext } from "react";
// import {
//   Modal,
//   Button,
//   Form,
//   Row,
//   Col,
//   InputGroup,
// } from "react-bootstrap";

// import { AppThemeContext } from "../../../../context/AppThemeContext";
// import { BaseUrl } from "../../../../api/AxiosApi";

// const UserDetailUpdate = ({
//   show,
//   handleClose,
//   userData,
//   onUpdate,
// }) => {
//   const { PrimaryColor } = useContext(AppThemeContext);

//   const [formData, setFormData] = useState({
//     userId: "",
//     username: "",
//     plant_capacity: "",
//     dc_capacity: "",
//     address: "",
//     city: "",
//     currency: "",
//     lat: "",
//     long: "",
//     rate: "",
//     co2_rate: "",
//     total_modules: "",
//     module_capacity: "",
//     module_make: "",
//   });

//   const LOGIN_ID = sessionStorage.getItem("LoginID");

//   useEffect(() => {
//     if (userData) {
//       setFormData({
//         userId: userData.user_id || "",
//         username: userData.username || "",
//         plant_capacity: userData.plant_capacity || "",
//         dc_capacity: userData.dc_capacity || "",
//         address: userData.address || "",
//         city: userData.city || "",
//         currency: userData.currency || "",
//         lat: userData.lat || "",
//         long: userData.long || "",
//         rate: userData.rate || "",
//         co2_rate: userData.co2_rate || "",
//         total_modules: userData.total_modules || "",
//         module_capacity: userData.module_capacity || "",
//         module_make: userData.module_make || "",
//       });
//     }
//   }, [userData]);

//   // HANDLE CHANGE
//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     setFormData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   // SUBMIT UPDATE
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     try {
//       const queryParams = new URLSearchParams({
//         USER_NAME: formData.username,
//         PLANT_CAPACITY: formData.plant_capacity,
//         DC_CAPACITY: formData.dc_capacity,
//         ADDRESS: formData.address,
//         CITY: formData.city,
//         CURRENCY: formData.currency,
//         LATITUDE: formData.lat,
//         LONGITUDE: formData.long,
//         RATE: formData.rate,
//         CO2: formData.co2_rate,
//         TOTAL_MODULES: formData.total_modules,
//         MODULE_CAPACITY: formData.module_capacity,
//         MODULE_MAKE: formData.module_make,
//         SKey: "XYZ",
//       }).toString();

//       const body = new URLSearchParams({
//         USER_ID: LOGIN_ID,
//         UPDATE_ID: formData.userId,
//         TYPE_ID: "U",
//       }).toString();

//       const url = `${BaseUrl}UPDATE_USER?${queryParams}`;

//       const res = await fetch(url, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/x-www-form-urlencoded",
//         },
//         body: body,
//       });

//       const data = await res.json();

//       console.log("UPDATE RESPONSE:", data);

//       if (data.success || data.STATUS === "SUCCESS") {
//         onUpdate(data);
//         handleClose();
//       } else {
//         alert("Update failed");
//       }
//     } catch (err) {
//       console.error(err);
//       alert("Something went wrong");
//     }
//   };

//   return (
//     <Modal show={show} onHide={handleClose} centered size="lg">
//       {/* HEADER */}
//       <Modal.Header
//         closeButton
//         style={{
//           background: PrimaryColor,
//           color: "#fff",
//         }}
//       >
//         <Modal.Title style={{ color: "#fff" }}>
//           Update User Details
//         </Modal.Title>
//       </Modal.Header>

//       <Modal.Body>
//         <Form onSubmit={handleSubmit}>
//           <Row>
//             {/* USER ID */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>User ID</Form.Label>

//                 <Form.Control
//                   type="text"
//                   value={formData.userId}
//                   readOnly
//                 />
//               </Form.Group>
//             </Col>

//             {/* USER NAME */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>User Name</Form.Label>

//                 <Form.Control
//                   name="username"
//                   value={formData.username}
//                   onChange={handleChange}
//                 />
//               </Form.Group>
//             </Col>

//             {/* CITY */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>City</Form.Label>

//                 <Form.Control
//                   name="city"
//                   value={formData.city}
//                   onChange={handleChange}
//                 />
//               </Form.Group>
//             </Col>

//             {/* PLANT CAPACITY */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>Plant Capacity</Form.Label>

//                 <InputGroup>
//                   <Form.Control
//                     name="plant_capacity"
//                     value={formData.plant_capacity}
//                     onChange={handleChange}
//                   />

//                   <InputGroup.Text>
//                     {userData?.AC_Unit || "KWp"}
//                   </InputGroup.Text>
//                 </InputGroup>
//               </Form.Group>
//             </Col>

//             {/* DC CAPACITY */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>DC Capacity</Form.Label>

//                 <InputGroup>
//                   <Form.Control
//                     name="dc_capacity"
//                     value={formData.dc_capacity}
//                     onChange={handleChange}
//                   />

//                   <InputGroup.Text>
//                     {userData?.DC_Unit || "KW"}
//                   </InputGroup.Text>
//                 </InputGroup>
//               </Form.Group>
//             </Col>

//             {/* CURRENCY */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>Currency</Form.Label>

//                 <Form.Control
//                   name="currency"
//                   value={formData.currency}
//                   onChange={handleChange}
//                 />
//               </Form.Group>
//             </Col>

//             {/* RATE */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>Rate</Form.Label>

//                 <Form.Control
//                   name="rate"
//                   value={formData.rate}
//                   onChange={handleChange}
//                 />
//               </Form.Group>
//             </Col>

//             {/* LATITUDE */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>Latitude</Form.Label>

//                 <Form.Control
//                   name="lat"
//                   value={formData.lat}
//                   onChange={handleChange}
//                 />
//               </Form.Group>
//             </Col>

//             {/* LONGITUDE */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>Longitude</Form.Label>

//                 <Form.Control
//                   name="long"
//                   value={formData.long}
//                   onChange={handleChange}
//                 />
//               </Form.Group>
//             </Col>

//             {/* CO2 */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>CO2 Reduction</Form.Label>

//                 <Form.Control
//                   name="co2_rate"
//                   value={formData.co2_rate}
//                   onChange={handleChange}
//                 />
//               </Form.Group>
//             </Col>

//             {/* TOTAL MODULES */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>Total Modules</Form.Label>

//                 <Form.Control
//                   name="total_modules"
//                   value={formData.total_modules}
//                   onChange={handleChange}
//                 />
//               </Form.Group>
//             </Col>

//             {/* MODULE CAPACITY */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>Module Capacity</Form.Label>

//                 <Form.Control
//                   name="module_capacity"
//                   value={formData.module_capacity}
//                   onChange={handleChange}
//                 />
//               </Form.Group>
//             </Col>

//             {/* MODULE MAKE */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>Module Make</Form.Label>

//                 <Form.Control
//                   name="module_make"
//                   value={formData.module_make}
//                   onChange={handleChange}
//                 />
//               </Form.Group>
//             </Col>
//           </Row>

//           {/* ADDRESS */}
//           <Form.Group className="mb-2">
//             <Form.Label>Address</Form.Label>

//             <Form.Control
//               as="textarea"
//               rows={2}
//               name="address"
//               value={formData.address}
//               onChange={handleChange}
//             />
//           </Form.Group>

//           {/* BUTTONS */}
//           <div className="text-end mt-2">
//             <Button
//               variant="secondary"
//               onClick={handleClose}
//               style={{ marginRight: "10px" }}
//             >
//               Cancel
//             </Button>

//             <Button
//               type="submit"
//               style={{
//                 background: PrimaryColor,
//                 border: "none",
//               }}
//             >
//               Update
//             </Button>
//           </div>
//         </Form>
//       </Modal.Body>
//     </Modal>
//   );
// };

// export default UserDetailUpdate;


// 4. witout conditon

// import { useEffect, useState, useContext } from "react";
// import {
//   Modal,
//   Button,
//   Form,
//   Row,
//   Col,
//   InputGroup,
// } from "react-bootstrap";

// import { AppThemeContext } from "../../../../context/AppThemeContext";

// const UserDetailUpdate = ({
//   show,
//   handleClose,
//   userData,
//   onUpdate,
// }) => {
//   const { PrimaryColor } = useContext(AppThemeContext);

//   const [formData, setFormData] = useState({
//     userId: "",
//     username: "",
//     plant_capacity: "",
//     dc_capacity: "",
//     address: "",
//     city: "",
//     country: "INDIA",
//     currency: "",
//     lat: "",
//     long: "",
//     rate: "",
//     co2_rate: "",
//     total_modules: "",
//     module_capacity: "",
//     module_make: "",
//   });

//   useEffect(() => {
//     if (userData) {
//       setFormData({
//         userId: userData.user_id || "",
//         username: userData.username || "",
//         plant_capacity: userData.plant_capacity || "",
//         dc_capacity: userData.dc_capacity || "",
//         address: userData.address || "",
//         city: userData.city || "",
//         country: userData.country || "INDIA",
//         currency: userData.currency || "",
//         lat: userData.lat || "",
//         long: userData.long || "",
//         rate: userData.rate || "",
//         co2_rate: userData.co2_rate || "",
//         total_modules: userData.total_modules || "",
//         module_capacity: userData.module_capacity || "",
//         module_make: userData.module_make || "",
//       });
//     }
//   }, [userData]);

//   // HANDLE CHANGE
//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     setFormData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   // UPDATE API
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     try {
//       const url =
//         `https://log.poweramr.com/api/CMN_10_Update/PLANT_DET?` +
//         `USER_NAME=${encodeURIComponent(formData.username)}` +
//         `&ADDRESS=${encodeURIComponent(formData.address)}` +
//         `&CITY=${encodeURIComponent(formData.city)}` +
//         `&COUNTRY=${encodeURIComponent(formData.country)}` +
//         `&PLANT_CAPACITY=${encodeURIComponent(formData.plant_capacity)}` +
//         `&DC_CAPACITY=${encodeURIComponent(formData.dc_capacity)}` +
//         `&LATITUDE=${encodeURIComponent(formData.lat)}` +
//         `&LONGITUDE=${encodeURIComponent(formData.long)}` +
//         `&RATE=${encodeURIComponent(formData.rate)}` +
//         `&CURRENCY=${encodeURIComponent(formData.currency)}` +
//         `&CO2=${encodeURIComponent(formData.co2_rate)}` +
//         `&TOTAL_NO_MODULE=${encodeURIComponent(
//           formData.total_modules
//         )}` +
//         `&EACH_MODULE_CAPACITY=${encodeURIComponent(
//           formData.module_capacity
//         )}` +
//         `&MODULE_MAKE=${encodeURIComponent(
//           formData.module_make
//         )}`;

//       const body = new URLSearchParams({
//         LOGIN_ID: "Demo@in",
//         PASS_KEY: "xerere123",
//         WEB_KEY: "XYXABC321",
//       });

//       const response = await fetch(url, {
//         method: "POST",
//         headers: {
//           "Content-Type":
//             "application/x-www-form-urlencoded",
//         },
//         body,
//       });

//       const data = await response.json();

//       console.log("UPDATE RESPONSE:", data);

//       if (data.success === true) {
//         alert(`User Updated Successfully${data.data}`);

//         if (onUpdate) {
//           onUpdate(data);
//         }

//         handleClose();
//       } else {
//         alert("Update Failed");
//       }
//     } catch (error) {
//       console.error("UPDATE ERROR:", error);
//       alert("Something went wrong");
//     }
//   };

//   return (
//     <Modal
//       show={show}
//       onHide={handleClose}
//       centered
//       size="lg"
//     >
//       {/* HEADER */}
//       <Modal.Header
//         closeButton
//         style={{
//           background: PrimaryColor,
//           color: "#fff",
//         }}
//       >
//         <Modal.Title style={{ color: "#fff" }}>
//           Update User Details
//         </Modal.Title>
//       </Modal.Header>

//       <Modal.Body>
//         <Form onSubmit={handleSubmit}>
//           <Row>
//             {/* USER ID */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>User ID</Form.Label>

//                 <Form.Control
//                   type="text"
//                   value={formData.userId}
//                   readOnly
//                 />
//               </Form.Group>
//             </Col>

//             {/* USER NAME */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>User Name</Form.Label>

//                 <Form.Control
//                   name="username"
//                   value={formData.username}
//                   onChange={handleChange}
//                 />
//               </Form.Group>
//             </Col>

//             {/* CITY */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>City</Form.Label>

//                 <Form.Control
//                   name="city"
//                   value={formData.city}
//                   onChange={handleChange}
//                 />
//               </Form.Group>
//             </Col>

//             {/* PLANT CAPACITY */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>Plant Capacity</Form.Label>

//                 <InputGroup>
//                   <Form.Control
//                     name="plant_capacity"
//                     value={formData.plant_capacity}
//                     onChange={handleChange}
//                   />

//                   <InputGroup.Text>
//                     {userData?.AC_Unit || "KWp"}
//                   </InputGroup.Text>
//                 </InputGroup>
//               </Form.Group>
//             </Col>

//             {/* DC CAPACITY */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>DC Capacity</Form.Label>

//                 <InputGroup>
//                   <Form.Control
//                     name="dc_capacity"
//                     value={formData.dc_capacity}
//                     onChange={handleChange}
//                   />

//                   <InputGroup.Text>
//                     {userData?.DC_Unit || "KW"}
//                   </InputGroup.Text>
//                 </InputGroup>
//               </Form.Group>
//             </Col>

//             {/* CURRENCY */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>Currency</Form.Label>

//                 <Form.Control
//                   name="currency"
//                   value={formData.currency}
//                   onChange={handleChange}
//                 />
//               </Form.Group>
//             </Col>

//             {/* RATE */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>Rate</Form.Label>

//                 <Form.Control
//                   name="rate"
//                   value={formData.rate}
//                   onChange={handleChange}
//                 />
//               </Form.Group>
//             </Col>

//             {/* LATITUDE */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>Latitude</Form.Label>

//                 <Form.Control
//                   name="lat"
//                   value={formData.lat}
//                   onChange={handleChange}
//                 />
//               </Form.Group>
//             </Col>

//             {/* LONGITUDE */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>Longitude</Form.Label>

//                 <Form.Control
//                   name="long"
//                   value={formData.long}
//                   onChange={handleChange}
//                 />
//               </Form.Group>
//             </Col>

//             {/* CO2 */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>CO2 Reduction</Form.Label>

//                 <Form.Control
//                   name="co2_rate"
//                   value={formData.co2_rate}
//                   onChange={handleChange}
//                 />
//               </Form.Group>
//             </Col>

//             {/* TOTAL MODULES */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>Total Modules</Form.Label>

//                 <Form.Control
//                   name="total_modules"
//                   value={formData.total_modules}
//                   onChange={handleChange}
//                 />
//               </Form.Group>
//             </Col>

//             {/* MODULE CAPACITY */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>Each Module Capacity</Form.Label>

//                 <Form.Control
//                   name="module_capacity"
//                   value={formData.module_capacity}
//                   onChange={handleChange}
//                 />
//               </Form.Group>
//             </Col>

//             {/* MODULE MAKE */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>Module Make</Form.Label>

//                 <Form.Control
//                   name="module_make"
//                   value={formData.module_make}
//                   onChange={handleChange}
//                 />
//               </Form.Group>
//             </Col>
//           </Row>

//           {/* ADDRESS */}
//           <Form.Group className="mb-2">
//             <Form.Label>Address</Form.Label>

//             <Form.Control
//               as="textarea"
//               rows={2}
//               name="address"
//               value={formData.address}
//               onChange={handleChange}
//             />
//           </Form.Group>

//           {/* BUTTONS */}
//           <div className="text-end mt-2">
//             <Button
//               variant="secondary"
//               onClick={handleClose}
//               style={{ marginRight: "10px" }}
//             >
//               Cancel
//             </Button>

//             <Button
//               type="submit"
//               style={{
//                 background: PrimaryColor,
//                 border: "none",
//               }}
//             >
//               Update
//             </Button>
//           </div>
//         </Form>
//       </Modal.Body>
//     </Modal>
//   );
// };

// export default UserDetailUpdate;

// 5. without password

// import { useEffect, useState, useContext } from "react";
// import {
//   Modal,
//   Button,
//   Form,
//   Row,
//   Col,
//   InputGroup,
// } from "react-bootstrap";

// import { AppThemeContext } from "../../../../context/AppThemeContext";
// import { BaseUrl } from "../../../../api/AxiosApi";


// const UserDetailUpdate = ({
//   show,
//   handleClose,
//   userData,
//   onUpdate,
// }) => {
//   const { PrimaryColor } = useContext(AppThemeContext);
// const LOGIN_ID = sessionStorage.getItem("LoginID") || "";

//   const [formData, setFormData] = useState({
//     userId: "",
//     username: "",
//     plant_capacity: "",
//     dc_capacity: "",
//     address: "",
//     city: "",
//     country: "INDIA",
//     currency: "",
//     lat: "",
//     long: "",
//     rate: "",
//     co2_rate: "",
//     total_modules: "",
//     module_capacity: "",
//     module_make: "",
//   });

//   useEffect(() => {
//     if (userData) {
//       setFormData({
//         userId: userData.user_id || "",
//         username: userData.username || "",
//         plant_capacity: userData.plant_capacity || "",
//         dc_capacity: userData.dc_capacity || "",
//         address: userData.address || "",
//         city: userData.city || "",
//         country: userData.country || "INDIA",
//         currency: userData.currency || "",
//         lat: userData.lat || "",
//         long: userData.long || "",
//         rate: userData.rate || "",
//         co2_rate: userData.co2_rate || "",
//         total_modules: userData.total_modules || "",
//         module_capacity: userData.module_capacity || "",
//         module_make: userData.module_make || "",
//       });
//     }
//   }, [userData]);

//   // HANDLE CHANGE
//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     // NUMERIC FIELDS
//     const numericFields = [
//       "plant_capacity",
//       "dc_capacity",
//       "lat",
//       "long",
//       "rate",
//       "co2_rate",
//       "total_modules",
//       "module_capacity",
//     ];

//     // ALLOW ONLY NUMBERS + DECIMAL
//     if (numericFields.includes(name)) {
//       const numericValue = value.replace(/[^0-9.]/g, "");

//       // PREVENT MULTIPLE DOTS
//       const validValue = numericValue
//         .split(".")
//         .slice(0, 2)
//         .join(".");

//       setFormData((prev) => ({
//         ...prev,
//         [name]: validValue,
//       }));

//       return;
//     }

//     setFormData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   // UPDATE API
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     // REQUIRED VALIDATION
//     if (
//       !formData.username ||
//       !formData.address ||
//       !formData.city ||
//       !formData.plant_capacity ||
//       !formData.dc_capacity ||
//       !formData.lat ||
//       !formData.long ||
//       !formData.rate ||
//       !formData.co2_rate ||
//       !formData.total_modules ||
//       !formData.module_capacity ||
//       !formData.module_make
//     ) {
//       alert("Please fill all fields");
//       return;
//     }

//     try {
//       const url =
//         `${BaseUrl}CMN_10_Update/PLANT_DET?` +
//         `USER_NAME=${encodeURIComponent(
//           formData.username
//         )}` +
//         `&ADDRESS=${encodeURIComponent(
//           formData.address
//         )}` +
//         `&CITY=${encodeURIComponent(formData.city)}` +
//         `&COUNTRY=${encodeURIComponent(
//           formData.country
//         )}` +
//         `&PLANT_CAPACITY=${encodeURIComponent(
//           formData.plant_capacity
//         )}` +
//         `&DC_CAPACITY=${encodeURIComponent(
//           formData.dc_capacity
//         )}` +
//         `&LATITUDE=${encodeURIComponent(formData.lat)}` +
//         `&LONGITUDE=${encodeURIComponent(
//           formData.long
//         )}` +
//         `&RATE=${encodeURIComponent(formData.rate)}` +
//         `&CURRENCY=${encodeURIComponent(
//           formData.currency
//         )}` +
//         `&CO2=${encodeURIComponent(
//           formData.co2_rate
//         )}` +
//         `&TOTAL_NO_MODULE=${encodeURIComponent(
//           formData.total_modules
//         )}` +
//         `&EACH_MODULE_CAPACITY=${encodeURIComponent(
//           formData.module_capacity
//         )}` +
//         `&MODULE_MAKE=${encodeURIComponent(
//           formData.module_make
//         )}`;

//       // BODY DATA
//       const bodyData = new URLSearchParams();

//       bodyData.append("LOGIN_ID", LOGIN_ID);
//       bodyData.append("PASS_KEY", "xerere123");
//       bodyData.append("WEB_KEY", "XYXABC321");

//       // console.log("API URL:", url);

//       const response = await fetch(url, {
//         method: "POST",
//         headers: {
//           "Content-Type":
//             "application/x-www-form-urlencoded",
//         },     
//         body: bodyData.toString(),
//       });

//       const data = await response.json();

//       console.log("UPDATE RESPONSE:", data);

//       if (data.success === true) {
//        alert(`User Updated Successfully (${data.data})`);

//         if (onUpdate) {
//           onUpdate(data);
//         }

//         handleClose();
//       } else {
//         alert("Update Failed");
//       }
//     } catch (error) {
//       console.error("UPDATE ERROR:", error);
//       alert("Something went wrong");
//     }
//   };

//   return (
//     <Modal
//       show={show}
//       onHide={handleClose}
//       centered
//       size="lg"
//     >
//       {/* HEADER */}
//       <Modal.Header
//         closeButton
//         style={{
//           background: PrimaryColor,
//           color: "#fff",
//         }}
//       >
//         <Modal.Title style={{ color: "#fff" }}>
//           Update User Details
//         </Modal.Title>
//       </Modal.Header>

//       <Modal.Body>
//         <Form onSubmit={handleSubmit}>
//           <Row>
//             {/* USER ID */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>User ID</Form.Label>

//                 <Form.Control
//                   type="text"
//                   value={formData.userId}
//                   readOnly
//                 />
//               </Form.Group>
//             </Col>

//             {/* USER NAME */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>User Name</Form.Label>

//                 <Form.Control
//                   name="username"
//                   value={formData.username}
//                   onChange={handleChange}
//                 />
//               </Form.Group>
//             </Col>

//             {/* CITY */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>City</Form.Label>

//                 <Form.Control
//                   name="city"
//                   value={formData.city}
//                   onChange={handleChange}
//                 />
//               </Form.Group>
//             </Col>

//             {/* PLANT CAPACITY */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>Plant AC Capacity</Form.Label>

//                 <InputGroup>
//                   <Form.Control
//                     type="number"
//                     step="any"
//                     name="plant_capacity"
//                     value={formData.plant_capacity}
//                     onChange={handleChange}
//                   />

//                   <InputGroup.Text>
//                     {userData?.AC_Unit || "KWp"}
//                   </InputGroup.Text>
//                 </InputGroup>
//               </Form.Group>
//             </Col>

//             {/* DC CAPACITY */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>Plant DC Capacity</Form.Label>

//                 <InputGroup>
//                   <Form.Control
//                     type="number"
//                     step="any"
//                     name="dc_capacity"
//                     value={formData.dc_capacity}
//                     onChange={handleChange}
//                   />

//                   <InputGroup.Text>
//                     {userData?.DC_Unit || "KW"}
//                   </InputGroup.Text>
//                 </InputGroup>
//               </Form.Group>
//             </Col>

//             {/* CURRENCY */}
//             {/* <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>Currency</Form.Label>

//                 <Form.Control
//                   name="currency"
//                   value={formData.currency}
//                   onChange={handleChange}
//                 />
//               </Form.Group>
//             </Col> */}

//             {/* CURRENCY */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>Currency</Form.Label>

//                 <InputGroup>
//                   {/* <InputGroup.Text>₹</InputGroup.Text> */}

//                   <Form.Control
//                     value="₹"
//                     readOnly
//                     style={{
//                       backgroundColor: "#fff",
//                     }}
//                   />
//                 </InputGroup>
//               </Form.Group>
//             </Col>

//             {/* RATE */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>Electricity Rate</Form.Label>

//                 <Form.Control
//                   type="number"
//                   step="any"
//                   name="rate"
//                   value={formData.rate}
//                   onChange={handleChange}
//                 />
//               </Form.Group>
//             </Col>

//             {/* LATITUDE */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>Latitude</Form.Label>

//                 <Form.Control
//                   type="number"
//                   step="any"
//                   name="lat"
//                   value={formData.lat}
//                   onChange={handleChange}
//                 />
//               </Form.Group>
//             </Col>

//             {/* LONGITUDE */}

//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>Longitude</Form.Label>

//                 <Form.Control
//                   type="number"
//                   step="any"
//                   name="long"
//                   value={formData.long}
//                   onChange={handleChange}
//                 />
//               </Form.Group>
//             </Col>

//             {/* CO2 */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>CO2 Reduction Rate</Form.Label>

//                 <Form.Control
//                   type="number"
//                   step="any"
//                   name="co2_rate"
//                   value={formData.co2_rate}
//                   onChange={handleChange}
//                 />
//               </Form.Group>
//             </Col>

//             {/* TOTAL MODULES */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>Total Modules</Form.Label>

//                 <Form.Control
//                   type="number"
//                   step="any"
//                   name="total_modules"
//                   value={formData.total_modules}
//                   onChange={handleChange}
//                 />
//               </Form.Group>
//             </Col>

//             {/* MODULE CAPACITY */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>
//                   Each Module Capacity
//                 </Form.Label>

//                 <Form.Control
//                   type="number"
//                   step="any"
//                   name="module_capacity"
//                   value={formData.module_capacity}
//                   onChange={handleChange}
//                 />
//               </Form.Group>
//             </Col>

//             {/* MODULE MAKE */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>Module Make</Form.Label>

//                 <Form.Control
//                   name="module_make"
//                   value={formData.module_make}
//                   onChange={handleChange}
//                 />
//               </Form.Group>
//             </Col>
//           </Row>

//           {/* ADDRESS */}
//           <Form.Group className="mb-2">
//             <Form.Label>Address</Form.Label>

//             <Form.Control
//               as="textarea"
//               rows={2}
//               name="address"
//               value={formData.address}
//               onChange={handleChange}
//             />
//           </Form.Group>

//           {/* BUTTONS */}
//           <div className="text-end mt-2">
//             <Button
//               variant="secondary"
//               onClick={handleClose}
//               style={{ marginRight: "10px" }}
//             >
//               Cancel
//             </Button>

//             <Button
//               type="submit"
//               style={{
//                 background: PrimaryColor,
//                 border: "none",
//               }}
//             >
//               Update
//             </Button>
//           </div>
//         </Form>
//       </Modal.Body>
//     </Modal>
//   );
// };

// export default UserDetailUpdate;

// 6. password ata hai

// import { useEffect, useState, useContext } from "react";
// import {
//   Modal,
//   Button,
//   Form,
//   Row,
//   Col,
//   InputGroup,
// } from "react-bootstrap";

// import { AppThemeContext } from "../../../../context/AppThemeContext";
// import { BaseUrl } from "../../../../api/AxiosApi";

// const UserDetailUpdate = ({
//   show,
//   handleClose,
//   userData,
//   onUpdate,
// }) => {
//   const { PrimaryColor } =
//     useContext(AppThemeContext);

//   // LOCAL STORAGE
//   const LOGIN_ID =
//     sessionStorage.getItem("LoginID") || "";

//   const LOCAL_PASSWORD =
//     sessionStorage.getItem("PW") || "";

//   // FORM STATE
//   const [formData, setFormData] = useState({
//     userId: "",
//     username: "",
//     password: "",
//     plant_capacity: "",
//     dc_capacity: "",
//     address: "",
//     city: "",
//     country: "INDIA",
//     currency: "$",
//     lat: "",
//     long: "",
//     rate: "",
//     co2_rate: "",
//     total_modules: "",
//     module_capacity: "",
//     module_make: "",
//   });

//   // SET DATA
//   useEffect(() => {
//     if (userData) {
//       setFormData({
//         userId: userData.user_id || "",
//         username: userData.username || "",
//         password:
//           userData.password ||
//           LOCAL_PASSWORD ||
//           "",

//         plant_capacity:
//           userData.plant_capacity || "",

//         dc_capacity:
//           userData.dc_capacity || "",

//         address: userData.address || "",

//         city: userData.city || "",

//         country:
//           userData.country || "INDIA",

//         currency:
//           userData.currency || "$",

//         lat: userData.lat || "",

//         long: userData.long || "",

//         rate: userData.rate || "",

//         co2_rate:
//           userData.co2_rate || "",

//         total_modules:
//           userData.total_modules || "",

//         module_capacity:
//           userData.module_capacity || "",

//         module_make:
//           userData.module_make || "",
//       });
//     }
//   }, [userData, LOCAL_PASSWORD]);

//   // INPUT CHANGE
//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     // ONLY NUMBER FIELD
//     const numericFields = [
//       "plant_capacity",
//       "dc_capacity",
//       "lat",
//       "long",
//       "rate",
//       "co2_rate",
//       "total_modules",
//       "module_capacity",
//     ];

//     if (numericFields.includes(name)) {
//       const numericValue =
//         value.replace(/[^0-9.]/g, "");

//       const validValue = numericValue
//         .split(".")
//         .slice(0, 2)
//         .join(".");

//       setFormData((prev) => ({
//         ...prev,
//         [name]: validValue,
//       }));

//       return;
//     }

//     setFormData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   // SUBMIT
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     // VALIDATION
//     if (
//       !formData.username ||
//       !formData.password ||
//       !formData.address ||
//       !formData.city ||
//       !formData.plant_capacity ||
//       !formData.dc_capacity ||
//       !formData.lat ||
//       !formData.long ||
//       !formData.rate ||
//       !formData.co2_rate ||
//       !formData.total_modules ||
//       !formData.module_capacity ||
//       !formData.module_make
//     ) {
//       alert("Please fill all fields");
//       return;
//     }

//     try {
//       // API URL
//       const url =
//         `${BaseUrl}CMN_10_Update/PLANT_DET?` +
//         `USER_NAME=${encodeURIComponent(
//           formData.username
//         )}` +
//         `&ADDRESS=${encodeURIComponent(
//           formData.address
//         )}` +
//         `&CITY=${encodeURIComponent(
//           formData.city
//         )}` +
//         `&COUNTRY=${encodeURIComponent(
//           formData.country
//         )}` +
//         `&PLANT_CAPACITY=${encodeURIComponent(
//           formData.plant_capacity
//         )}` +
//         `&DC_CAPACITY=${encodeURIComponent(
//           formData.dc_capacity
//         )}` +
//         `&LATITUDE=${encodeURIComponent(
//           formData.lat
//         )}` +
//         `&LONGITUDE=${encodeURIComponent(
//           formData.long
//         )}` +
//         `&RATE=${encodeURIComponent(
//           formData.rate
//         )}` +
//         `&CURRENCY=${encodeURIComponent(
//           formData.currency
//         )}` +
//         `&CO2=${encodeURIComponent(
//           formData.co2_rate
//         )}` +
//         `&TOTAL_NO_MODULE=${encodeURIComponent(
//           formData.total_modules
//         )}` +
//         `&EACH_MODULE_CAPACITY=${encodeURIComponent(
//           formData.module_capacity
//         )}` +
//         `&MODULE_MAKE=${encodeURIComponent(
//           formData.module_make
//         )}`;

//       // BODY DATA
//       const bodyData =
//         new URLSearchParams();

//       bodyData.append(
//         "LOGIN_ID",
//         LOGIN_ID
//       );

//       bodyData.append(
//         "PASS_KEY",
//         "xerere123"
//       );

//       bodyData.append(
//         "WEB_KEY",
//         "XYXABC321"
//       );

//       bodyData.append(
//         "PASSWORD",
//         formData.password
//       );

//       console.log(
//         "REQUEST URL:",
//         url
//       );

//       console.log(
//         "BODY DATA:",
//         bodyData.toString()
//       );

//       // API CALL
//       const response = await fetch(url, {
//         method: "POST",

//         headers: {
//           "Content-Type":
//             "application/x-www-form-urlencoded",
//         },

//         body: bodyData.toString(),
//       });

//       const data = await response.json();

//       console.log(
//         "UPDATE RESPONSE:",
//         data
//       );

//       if (data.success === true) {
//         alert("User Updated Successfully");

//         if (onUpdate) {
//           onUpdate(data);
//         }

//         handleClose();
//       } else {
//         alert(
//           data.message || "Update Failed"
//         );
//       }
//     } catch (error) {
//       console.error(
//         "UPDATE ERROR:",
//         error
//       );

//       alert("Something went wrong");
//     }
//   };

//   return (
//     <Modal
//       show={show}
//       onHide={handleClose}
//       centered
//       size="lg"
//     >
//       {/* HEADER */}
//       <Modal.Header
//         closeButton
//         style={{
//           background: PrimaryColor,
//           color: "#fff",
//         }}
//       >
//         <Modal.Title>
//           Update User Details
//         </Modal.Title>
//       </Modal.Header>

//       <Modal.Body>
//         <Form onSubmit={handleSubmit}>
//           <Row>
//             {/* USER ID */}
//             <Col md={6}>
//               <Form.Group className="mb-1">
//                 <Form.Label>
//                   User ID
//                 </Form.Label>

//                 <Form.Control
//                   type="text"
//                   value={formData.userId}
//                   readOnly
//                 />
//               </Form.Group>
//             </Col>

//             {/* PASSWORD */}
//             <Col md={6}>
//               <Form.Group className="mb-1">
//                 <Form.Label>
//                   Password
//                 </Form.Label>

//                 <Form.Control
//                   type="password"
//                   name="password"
//                   value={formData.password}
//                   onChange={handleChange}
//                   placeholder="Enter Password"
//                   required
//                 />
//               </Form.Group>
//             </Col>

//             {/* USERNAME */}
//             <Col md={6}>
//               <Form.Group className="mb-1">
//                 <Form.Label>
//                   User Name
//                 </Form.Label>

//                 <Form.Control
//                   type="text"
//                   name="username"
//                   value={formData.username}
//                   onChange={handleChange}
//                   required
//                 />
//               </Form.Group>
//             </Col>

//             {/* CITY */}
//             <Col md={6}>
//               <Form.Group className="mb-1">
//                 <Form.Label>
//                   City
//                 </Form.Label>

//                 <Form.Control
//                   type="text"
//                   name="city"
//                   value={formData.city}
//                   onChange={handleChange}
//                   required
//                 />
//               </Form.Group>
//             </Col>

//             {/* AC CAPACITY */}
//             <Col md={6}>
//               <Form.Group className="mb-1">
//                 <Form.Label>
//                   Plant AC Capacity
//                 </Form.Label>

//                 <InputGroup>
//                   <Form.Control
//                     type="number"
//                     step="any"
//                     name="plant_capacity"
//                     value={
//                       formData.plant_capacity
//                     }
//                     onChange={handleChange}
//                     required
//                   />

//                   <InputGroup.Text>
//                     {userData?.AC_Unit ||
//                       "KWp"}
//                   </InputGroup.Text>
//                 </InputGroup>
//               </Form.Group>
//             </Col>

//             {/* DC CAPACITY */}
//             <Col md={6}>
//               <Form.Group className="mb-1">
//                 <Form.Label>
//                   Plant DC Capacity
//                 </Form.Label>

//                 <InputGroup>
//                   <Form.Control
//                     type="number"
//                     step="any"
//                     name="dc_capacity"
//                     value={
//                       formData.dc_capacity
//                     }
//                     onChange={handleChange}
//                     required
//                   />

//                   <InputGroup.Text>
//                     {userData?.DC_Unit ||
//                       "KW"}
//                   </InputGroup.Text>
//                 </InputGroup>
//               </Form.Group>
//             </Col>

//             {/* CURRENCY */}
//             <Col md={6}>
//               <Form.Group className="mb-1">
//                 <Form.Label>
//                   Currency
//                 </Form.Label>

//                 <Form.Control
//                   type="text"
//                  value="₹"
//                   readOnly
//                   style={{
//                     backgroundColor: "#fff",
//                   }}
//                 />
//               </Form.Group>
//             </Col>

//             {/* RATE */}
//             <Col md={6}>
//               <Form.Group className="mb-1">
//                 <Form.Label>
//                   Electricity Rate
//                 </Form.Label>

//                 <Form.Control
//                   type="number"
//                   step="any"
//                   name="rate"
//                   value={formData.rate}
//                   onChange={handleChange}
//                   required
//                 />
//               </Form.Group>
//             </Col>

//             {/* LATITUDE */}
//             <Col md={6}>
//               <Form.Group className="mb-1">
//                 <Form.Label>
//                   Latitude
//                 </Form.Label>

//                 <Form.Control
//                   type="number"
//                   step="any"
//                   name="lat"
//                   value={formData.lat}
//                   onChange={handleChange}
//                   required
//                 />
//               </Form.Group>
//             </Col>

//             {/* LONGITUDE */}
//             <Col md={6}>
//               <Form.Group className="mb-1">
//                 <Form.Label>
//                   Longitude
//                 </Form.Label>

//                 <Form.Control
//                   type="number"
//                   step="any"
//                   name="long"
//                   value={formData.long}
//                   onChange={handleChange}
//                   required
//                 />
//               </Form.Group>
//             </Col>

//             {/* CO2 */}
//             <Col md={6}>
//               <Form.Group className="mb-1">
//                 <Form.Label>
//                   CO2 Reduction Rate
//                 </Form.Label>

//                 <Form.Control
//                   type="number"
//                   step="any"
//                   name="co2_rate"
//                   value={formData.co2_rate}
//                   onChange={handleChange}
//                   required
//                 />
//               </Form.Group>
//             </Col>

//             {/* TOTAL MODULE */}
//             <Col md={6}>
//               <Form.Group className="mb-1">
//                 <Form.Label>
//                   Total Modules
//                 </Form.Label>

//                 <Form.Control
//                   type="number"
//                   step="any"
//                   name="total_modules"
//                   value={
//                     formData.total_modules
//                   }
//                   onChange={handleChange}
//                   required
//                 />
//               </Form.Group>
//             </Col>

//             {/* MODULE CAPACITY */}
//             <Col md={6}>
//               <Form.Group className="mb-1">
//                 <Form.Label>
//                   Each Module Capacity
//                 </Form.Label>

//                 <Form.Control
//                   type="number"
//                   step="any"
//                   name="module_capacity"
//                   value={
//                     formData.module_capacity
//                   }
//                   onChange={handleChange}
//                   required
//                 />
//               </Form.Group>
//             </Col>

//             {/* MODULE MAKE */}
//             <Col md={6}>
//               <Form.Group className="mb-1">
//                 <Form.Label>
//                   Module Make
//                 </Form.Label>

//                 <Form.Control
//                   type="text"
//                   name="module_make"
//                   value={
//                     formData.module_make
//                   }
//                   onChange={handleChange}
//                   required
//                 />
//               </Form.Group>
//             </Col>
//           </Row>

//           {/* ADDRESS */}
//           <Form.Group className="mb-1">
//             <Form.Label>
//               Address
//             </Form.Label>

//             <Form.Control
//               as="textarea"
//               rows={3}
//               name="address"
//               value={formData.address}
//               onChange={handleChange}
//               required
//             />
//           </Form.Group>

//           {/* BUTTON */}
//           <div className="text-end">
//             <Button
//               variant="secondary"
//               onClick={handleClose}
//               className="me-2"
//             >
//               Cancel
//             </Button>

//             <Button
//               type="submit"
//               style={{
//                 backgroundColor:
//                   PrimaryColor,
//                 border: "none",
//               }}
//             >
//               Update
//             </Button>
//           </div>
//         </Form>
//       </Modal.Body>
//     </Modal>
//   );
// };

// export default UserDetailUpdate;

// 7.

import { useEffect, useState, useContext } from "react";
import {
  Modal,
  Button,
  Form,
  Row,
  Col,
  InputGroup,
} from "react-bootstrap";

import { AppThemeContext } from "../../../../context/AppThemeContext";
import { BaseUrl } from "../../../../api/AxiosApi";

const UserDetailUpdate = ({
  show,
  handleClose,
  userData,
  onUpdate,
}) => {
  const { PrimaryColor } =
    useContext(AppThemeContext);

  // LOCAL STORAGE
  const LOGIN_ID =
    sessionStorage.getItem("LoginID") || "";

  // FORM STATE
  const [formData, setFormData] = useState({
    userId: "",
    username: "",
    password: "",
    plant_capacity: "",
    dc_capacity: "",
    address: "",
    city: "",
    country: "INDIA",
    currency: "₹",
    lat: "",
    long: "",
    rate: "",
    co2_rate: "",
    total_modules: "",
    module_capacity: "",
    module_make: "",
  });

  // SET DATA
  useEffect(() => {
    if (userData) {
      setFormData({
        userId: userData.user_id || "",
        username: userData.username || "",

        // PASSWORD BLANK BY DEFAULT
        password: "",

        plant_capacity:
          userData.plant_capacity || "",

        dc_capacity:
          userData.dc_capacity || "",

        address: userData.address || "",

        city: userData.city || "",

        country:
          userData.country || "INDIA",

        currency:
          userData.currency || "₹",

        lat: userData.lat || "",

        long: userData.long || "",

        rate: userData.rate || "",

        co2_rate:
          userData.co2_rate || "",

        total_modules:
          userData.total_modules || "",

        module_capacity:
          userData.module_capacity || "",

        module_make:
          userData.module_make || "",
      });
    }
  }, [userData]);

  // INPUT CHANGE
  const handleChange = (e) => {
    const { name, value } = e.target;

    // NUMBER FIELDS
    const numericFields = [
      "plant_capacity",
      "dc_capacity",
      "lat",
      "long",
      "rate",
      "co2_rate",
      "total_modules",
      "module_capacity",
    ];

    // ALLOW ONLY NUMBER + DOT
    if (numericFields.includes(name)) {
      const numericValue =
        value.replace(/[^0-9.]/g, "");

      const validValue = numericValue
        .split(".")
        .slice(0, 2)
        .join(".");

      setFormData((prev) => ({
        ...prev,
        [name]: validValue,
      }));

      return;
    }

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // SUBMIT
  const handleSubmit = async (e) => {
    e.preventDefault();

    // VALIDATION
    if (
      !formData.username ||
      !formData.password ||
      !formData.address ||
      !formData.city ||
      !formData.plant_capacity ||
      !formData.dc_capacity ||
      !formData.lat ||
      !formData.long ||
      !formData.rate ||
      !formData.co2_rate ||
      !formData.total_modules ||
      !formData.module_capacity ||
      !formData.module_make
    ) {
      alert("Please fill all fields");
      return;
    }

    try {
      // API URL
      const url =
        `${BaseUrl}CMN_10_Update/PLANT_DET?` +
        `USER_NAME=${encodeURIComponent(
          formData.username
        )}` +
        `&ADDRESS=${encodeURIComponent(
          formData.address
        )}` +
        `&CITY=${encodeURIComponent(
          formData.city
        )}` +
        `&COUNTRY=${encodeURIComponent(
          formData.country
        )}` +
        `&PLANT_CAPACITY=${encodeURIComponent(
          formData.plant_capacity
        )}` +
        `&DC_CAPACITY=${encodeURIComponent(
          formData.dc_capacity
        )}` +
        `&LATITUDE=${encodeURIComponent(
          formData.lat
        )}` +
        `&LONGITUDE=${encodeURIComponent(
          formData.long
        )}` +
        `&RATE=${encodeURIComponent(
          formData.rate
        )}` +
        `&CURRENCY=${encodeURIComponent(
          formData.currency
        )}` +
        `&CO2=${encodeURIComponent(
          formData.co2_rate
        )}` +
        `&TOTAL_NO_MODULE=${encodeURIComponent(
          formData.total_modules
        )}` +
        `&EACH_MODULE_CAPACITY=${encodeURIComponent(
          formData.module_capacity
        )}` +
        `&MODULE_MAKE=${encodeURIComponent(
          formData.module_make
        )}`;

      // BODY DATA
      const bodyData =
        new URLSearchParams();

      bodyData.append(
        "LOGIN_ID",
        LOGIN_ID
      );

      bodyData.append(
        "PASS_KEY",
        "XYZ"
      );

      bodyData.append(
        "WEB_KEY",
        "WEBXYZ321"
      );

      // USER ENTERED PASSWORD
      bodyData.append(
        "PASSWORD",
        formData.password
      );

      console.log(
        "REQUEST URL:",
        url
      );

      console.log(
        "BODY DATA:",
        bodyData.toString()
      );

      // API CALL
      const response = await fetch(url, {
        method: "POST",

        headers: {
          "Content-Type":
            "application/x-www-form-urlencoded",
        },

        body: bodyData.toString(),
      });

      const data = await response.json();

      console.log(
        "UPDATE RESPONSE:",
        data
      );

      if (data.success === true) {
        alert(

          `User Updated Successfully (${data.data})`
        );

        if (onUpdate) {
          onUpdate(data);
        }

        handleClose();
      } else {
        alert(
          data.message ||
          "Update Failed"
        );
      }
    } catch (error) {
      console.error(
        "UPDATE ERROR:",
        error
      );

      alert("Something went wrong");
    }
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      size="lg"
    >
      {/* HEADER */}
      <Modal.Header
        closeButton
        style={{
          background: PrimaryColor,
          color: "#fff",
        }}
      >
        <Modal.Title>
          Update User Details
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Row>
            {/* USER ID */}
            <Col md={6}>
              <Form.Group className="mb-1">
                <Form.Label>
                  User ID
                </Form.Label>

                <Form.Control
                  type="text"
                  value={formData.userId}
                  readOnly
                />
              </Form.Group>
            </Col>

            {/* PASSWORD */}
            <Col md={6}>
              <Form.Group className="mb-1">
                <Form.Label>
                  Password
                </Form.Label>

                <Form.Control
                  type="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  placeholder="Enter Password"
                  required
                />
              </Form.Group>
            </Col>

            {/* USER NAME */}
            <Col md={6}>
              <Form.Group className="mb-1">
                <Form.Label>
                  User Name
                </Form.Label>

                <Form.Control
                  type="text"
                  name="username"
                  value={formData.username}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>

            {/* CITY */}
            <Col md={6}>
              <Form.Group className="mb-1">
                <Form.Label>
                  City
                </Form.Label>

                <Form.Control
                  type="text"
                  name="city"
                  value={formData.city}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>

            {/* COUNTRY */}
            <Col md={6}>
              <Form.Group className="mb-1">
                <Form.Label>
                  Country
                </Form.Label>

                <Form.Control
                  type="text"
                  name="country"
                  value={formData.country}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>

            {/* AC CAPACITY */}
            <Col md={6}>
              <Form.Group className="mb-1">
                <Form.Label>
                  Plant AC Capacity
                </Form.Label>

                <InputGroup>
                  <Form.Control
                    type="number"
                    step="any"
                    name="plant_capacity"
                    value={
                      formData.plant_capacity
                    }
                    onChange={handleChange}
                    required
                  />

                  <InputGroup.Text>
                    {userData?.AC_Unit ||
                      "kW"}
                  </InputGroup.Text>
                </InputGroup>
              </Form.Group>
            </Col>

            {/* DC CAPACITY */}
            <Col md={6}>
              <Form.Group className="mb-1">
                <Form.Label>
                  Plant DC Capacity
                </Form.Label>

                <InputGroup>
                  <Form.Control
                    type="number"
                    step="any"
                    name="dc_capacity"
                    value={
                      formData.dc_capacity
                    }
                    onChange={handleChange}
                    required
                  />

                  <InputGroup.Text>
                    {userData?.DC_Unit ||
                      "kWp"}
                  </InputGroup.Text>
                </InputGroup>
              </Form.Group>
            </Col>

            {/* CURRENCY */}
            <Col md={6}>
              <Form.Group className="mb-1">
                <Form.Label>
                  Currency
                </Form.Label>

                <Form.Control
                  type="text"
                  value="₹"
                  readOnly
                  style={{
                    backgroundColor: "#fff",
                  }}
                />
              </Form.Group>
            </Col>

            {/* RATE */}
            <Col md={6}>
              <Form.Group className="mb-1">
                <Form.Label>
                  Electricity Rate
                </Form.Label>

                <Form.Control
                  type="number"
                  step="any"
                  name="rate"
                  value={formData.rate}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>


            {/* CO2 */}
            <Col md={6}>
              <Form.Group className="mb-1">
                <Form.Label>
                  CO2 Reduction Rate
                </Form.Label>

                <Form.Control
                  type="number"
                  step="any"
                  name="co2_rate"
                  value={formData.co2_rate}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>


            {/* LATITUDE */}
            <Col md={6}>
              <Form.Group className="mb-1">
                <Form.Label>
                  Latitude
                </Form.Label>

                <Form.Control
                  type="number"
                  step="any"
                  name="lat"
                  value={formData.lat}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>

            {/* LONGITUDE */}
            <Col md={6}>
              <Form.Group className="mb-1">
                <Form.Label>
                  Longitude
                </Form.Label>

                <Form.Control
                  type="number"
                  step="any"
                  name="long"
                  value={formData.long}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>




            {/* TOTAL MODULES */}
            <Col md={6}>
              <Form.Group className="mb-1">
                <Form.Label>
                  Total Modules
                </Form.Label>

                <Form.Control
                  type="number"
                  step="any"
                  name="total_modules"
                  value={
                    formData.total_modules
                  }
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>

            {/* MODULE CAPACITY */}
            <Col md={6}>
              <Form.Group className="mb-1">
                <Form.Label>
                  Each Module Capacity
                </Form.Label>

                <Form.Control
                  type="number"
                  step="any"
                  name="module_capacity"
                  value={
                    formData.module_capacity
                  }
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>

            {/* MODULE MAKE */}
            <Col md={6}>
              <Form.Group className="mb-1">
                <Form.Label>
                  Module Make
                </Form.Label>

                <Form.Control
                  type="text"
                  name="module_make"
                  value={
                    formData.module_make
                  }
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>
          </Row>

          {/* ADDRESS */}
          <Form.Group className="mb-1">
            <Form.Label>
              Address
            </Form.Label>

            <Form.Control
              as="textarea"
              rows={3}
              name="address"
              value={formData.address}
              onChange={handleChange}
              required
            />
          </Form.Group>

          {/* BUTTONS */}
          <div className="text-end mt-2">
            <Button
              variant="secondary"
              onClick={handleClose}
              className="me-2"
            >
              Cancel
            </Button>

            <Button
              type="submit"
              style={{
                backgroundColor:
                  PrimaryColor,
                border: "none",
              }}
            >
              Update
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default UserDetailUpdate;